import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-display-text',
  template: require('./display-text.component.html'),
  styles: [require('./display-text.component.scss')],
})
export class DisplayTextComponent {
  @Input() field: string;
  @Input() value: any;
  @Input() isDate: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/display-text/display-text.component.ts